import { defineComponent } from 'vue';
import MessageBoxWithIcon from '@common/layout/messageBox/MessageBoxWithIcon.vue';
import RequiredFields from '@common/layout/RequiredFields.vue';
import ComponentSelection from '../atoms/ComponentSelection.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
import translator from '~/zf/frontend/common/mixins/translator';
import PreventionBehavior from '../atoms/PreventionBehavior.vue';
import Duration from '../atoms/Duration.vue';
import Reason from '../atoms/Reason.vue';
import ComponentType from '../../../../../portlet/viiu/alarms/const/ComponentType';
import AffectedComponent from '../atoms/AffectedComponent.vue';
export default defineComponent({
    name: 'ScheduledBody',
    components: {
        AffectedComponent,
        RequiredFields,
        Reason,
        Duration,
        PreventionBehavior,
        MessageBoxWithIcon,
        ComponentSelection,
    },
    mixins: [translator],
    compatConfig: {
        MODE: 3,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:model-value'],
    data() {
        return {
            BootstrapVariant,
            selectedComponent: null,
        };
    },
    computed: {
        shouldShowPreventionBehavior() {
            const allowedComponentTypes = [ComponentType.SYSTEM, ComponentType.DATALOGGER, ComponentType.INVERTER, ComponentType.STRINGBOX];
            return allowedComponentTypes.includes(this.modelValue.mutedComponent.componentType);
        },
        shouldShowAffectedComponents() {
            return this.selectedComponent !== null && this.modelValue.shouldCascade;
        },
    },
    watch: {
        selectedComponent: {
            handler(newValue) {
                const params = newValue.value.split('-');
                const mutedComponent = {
                    componentType: parseInt(params[0], 10),
                    componentId: parseInt(params[1], 10),
                };
                this.$emit('update:model-value', { ...this.modelValue, mutedComponent, ...{ shouldCascade: false } });
            },
            deep: true,
        },
    },
    methods: {
        updateDuration(update) {
            this.$emit('update:model-value', { ...this.modelValue, start: update[0], end: update[1] });
        },
    },
});
